module.exports = __webpack_public_path__ + "images/emoji/foggy.7a17302ce517f6c3cc4c.png";